import { getDefaultStore } from 'jotai';

import { useStandardAtom } from 'src/store/standard';

import standardConstants from './constants/standardConstants';

export const getTenantRedirectUri = () => {
  const { pathname } = window.location;
  const segments = pathname.split('/').filter(Boolean);

  // 로컬호스트인 경우 빈 문자열 반환
  if (window.location.hostname === 'localhost') {
    return '';
  }
  // 멀티테넌시 처리
  return segments[0] ?? '';
};

// 일반 함수에서 atom 값 읽기
export const isStandard = () => {
  const store = getDefaultStore();
  const standardValue = store.get(useStandardAtom);

  return standardValue === standardConstants.STANDARD;
};
